jQuery(function($){
	//Horizontal Accordion
	if($('.scfe-block-wrapper.horizontal-accordion .accordion-wrapper').length) {
		$('.scfe-block-wrapper.horizontal-accordion').each(function(){
			const el = $(this);
			setTimeout(function(){
				setHorizontalAccordionContentSize(el);
			}, 250);
		});

		$(window).on('resize', function(){
			setTimeout(function(){
				$('.scfe-block-wrapper.horizontal-accordion').each(function(){
					console.log('changed');
					const accordion = $(this);
					setHorizontalAccordionContentSize(accordion);

					accordion.find('.accordion-section').each(function(index, el){
						if(index === 0) {
							if($(el).hasClass('active')) {
								setMobileContentHeight($(el));
							}
						}
					});
				});
			}, 50);
		});

		const queryString = window.location.search;
		const urlParams = new URLSearchParams(queryString);

		let loadedAccordionSection = '';

		if(urlParams.get('accordion_section')) loadedAccordionSection = urlParams.get('accordion_section');

		console.log(urlParams);
		console.log(loadedAccordionSection);

		$('.accordion-wrapper').each(function(){
			$(this).find('.accordion-section').each(function(index, el){
				let activeSection = false;
				if(loadedAccordionSection.length) {
					$(el).find('.accordion-section-heading').each(function(){
						if($(this).attr('data-accordion-section') == loadedAccordionSection) activeSection = true;
					});
				} else {
					activeSection = index === 0;
				}
				if(activeSection) {
					changeAccordionSection($(el));
					$(el).closest('.accordion-wrapper').removeClass('loading');

					setTimeout(function(){
						setMobileContentHeight($(el));
					}, 50);
				}
			});
		});
	}

	//Vertical Accordion
	if($('.scfe-block-wrapper.vertical-accordion .accordion-wrapper').length) {
		$('.scfe-block-wrapper.vertical-accordion').each(function(){
			const el = $(this);
			setTimeout(function(){
				setHorizontalAccordionContentSize(el);
			}, 250);
		});

		$(window).on('resize', function(){
			setTimeout(function(){
				$('.scfe-block-wrapper.vertical-accordion').each(function(){
					console.log('changed');
					const accordion = $(this);
					setHorizontalAccordionContentSize(accordion);

					accordion.find('.accordion-section').each(function(index, el){
						if(index === 0) {
							if($(el).hasClass('active')) {
								setMobileContentHeight($(el));
							}
						}
					});
				});
			}, 50);
		});

		const queryString = window.location.search;
		const urlParams = new URLSearchParams(queryString);

		let loadedAccordionSection = '';

		if(urlParams.get('accordion_section')) loadedAccordionSection = urlParams.get('accordion_section');

		console.log(urlParams);
		console.log(loadedAccordionSection);

		$('.accordion-wrapper').each(function(){
			$(this).find('.accordion-section').each(function(index, el){
				let activeSection = false;
				if(loadedAccordionSection.length) {
					$(el).find('.accordion-section-heading').each(function(){
						if($(this).attr('data-accordion-section') == loadedAccordionSection) activeSection = true;
					});
				} else {
					activeSection = index === 0;
				}
				if(activeSection) {
					changeAccordionSection($(el));
					$(el).closest('.accordion-wrapper').removeClass('loading');

					setTimeout(function(){
						setMobileContentHeight($(el));
					}, 50);
				}
			});
		});
	}

	$('.scfe-block-wrapper.horizontal-accordion .scfe-block-wrapper.accordion-section').on('click', function(){
		changeAccordionSection($(this));
	});

	$('.scfe-block-wrapper.vertical-accordion .scfe-block-wrapper.accordion-section .accordion-section-heading').on('click', function(){
		const parentDiv = $(this).closest('.scfe-block-wrapper.vertical-accordion');
		const sections = parentDiv.find('.scfe-block-wrapper.accordion-section');
		const thisSection = $(this).closest('.scfe-block-wrapper.accordion-section');

		const wasActive = thisSection.hasClass('active');
		sections.removeClass('active');
		if(!wasActive) thisSection.addClass('active');
	});

	$('.accordion-tab').on('click', function(){
		const target = $(this).attr('data-accordion-target');
		if($('.scfe-block-wrapper.accordion-section [data-accordion-section="' + target + '"]').length) {
			const targetDiv = $('.scfe-block-wrapper.accordion-section [data-accordion-section="' + target + '"]');
			targetDiv.click();			
		}
	});

	function changeAccordionSection(el) {
		const parentDiv = el.closest('.horizontal-accordion');

		parentDiv.find('.accordion-section').removeClass('active');
		el.addClass('active');

		if(parentDiv.find('.accordion-tab').length) {
			parentDiv.find('.accordion-tab').removeClass('active');
			const targetTab = el.find('.accordion-section-heading').attr('data-accordion-section');
			parentDiv.find('.accordion-tab[data-accordion-target="' + targetTab + '"]').addClass('active');
		}
			
		if(!el.hasClass('active')) {
			setMobileContentHeight(el);
		}
	}

	function setMobileContentHeight(el) {
		const contentDiv = el.find('.accordion-section-wrapper-inner');
		let mobileContentHeight;
		contentDiv.each(function(){
			mobileContentHeight = this.getBoundingClientRect().height;
		});

		el.closest('.scfe-block-wrapper.horizontal-accordion').css('--mobile-content-height', mobileContentHeight + 'px');
	}

	function setHorizontalAccordionContentSize(el) {
		el.css('--content-width', 'initial');

		let contentWidth = 0;
		el.find('.accordion-section-wrapper-inner').each(function(){
			$(this).removeClass('absolute');
			const width = this.getBoundingClientRect().width;
			if(width > contentWidth) contentWidth = width;
		});

		el.css('--content-width', contentWidth + 'px');

		let contentHeight = 0;
		el.find('.accordion-section-wrapper-inner').each(function(){
			$(this).addClass('absolute');
			
			const height = this.getBoundingClientRect().height;
			if(height > contentHeight) contentHeight = height;
		});

		console.log(contentWidth);
		console.log(contentHeight);

		el.find('.accordion-section').css('height', 'calc(' + contentHeight + 'px + 60px)');		
	}
});